export class BadRequestResponse {
    errors: string[]

    static isBadRequestResponse(obj: any): obj is BadRequestResponse {
        return obj && obj.errors && Array.isArray(obj.errors);
    }
}
